<template>
  <div class="actions">
    <div v-if="!loading">
      <div v-if="actions.length < 1">

        <h1 v-if="!actions_status" class="actions__title">
          Simcard deamon not response
        </h1>

        <h1 v-else class="actions__title">
          {{translate('no_data')}}
        </h1>
      </div>

      <div v-else >
        <div v-if="error" style="height: 100%">
          <h1 style="text-align: center" >
            {{translate('no_data')}}
          </h1>
        </div>
        <div class="buttons_list">
          <ActionButton
            v-for="(action, index) in actions"
            :key="index"
            class="item"
            :action_data="action"
            :profile="profile"
            @reload="get_actions"
          />
        </div>
      </div>

      <TextTable
        :all_data = "all_data"
      />

    </div>

    <div v-else style="border:none; background-color:  transparent;">
      <scale-loader />
    </div>
  </div>
</template>

<script>
import ActionButton from './Actions/ActionButton.vue'
import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';

export default {
  name: 'Actions',
  components: {
    ActionButton,
    TextTable
  },

  props: ['sim_id', 'profile'],

  data () {
    return {
      actions: [],
      actions_status: true,
      error: false,
      loading: true,
      reload: false,
      status_list: {},
      all_data: {}
    }
  },
  watch:{
    reload(){
      if (this.reload) {
        this.interval = setInterval(() => {
          this.get_actions()
        }, this.$store.getters.getSimcardProfileActionsUpdate)
      }else{
        clearInterval(this.interval)
      }
    }
  },

  methods: {
    show_status(status_id){
      return this.status_list[status_id]
    },
    get_actions(){
      if (this.$route.name === 'simcard_profile_section') {
        this.$http.simcard.getSimcardActions(this.sim_id, (response) => {
          if (!response.data.actions) {
            this.global_notify('danger', this.translate('simcard.no_action'))
          }
          this.actions = response.data.actions
          this.reload = this.actions.length < 1 && this.actions_status;

          this.all_data = response.data.simcard_actions

          this.loading = false
        })
      }
    }
  },

  mounted () {
    this.get_actions()
  }
}
</script>
<style lang="scss" scoped>
  .actions{
    &__title{
      text-align: center;
      margin: 10px;
    }
    .response_table{
      height: auto;
    }
    .buttons_list{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .item{
        margin: 5px;
      }
    }
  }

 </style>
